import { apply, takeEvery } from "redux-saga/effects";
import { LOCAL_STORAGE_USER_THEME_KEY, LOCAL_STORAGE_APP_THEME_KEY, colorThemeSlice } from "./colorThemeReducer";

function* setUserThemeSaga({ payload }: ReturnType<typeof colorThemeSlice.actions.setUserThemeAction>) {
    yield apply(localStorage, 'setItem', [LOCAL_STORAGE_USER_THEME_KEY, payload]);
}

function* setAppThemeSaga({ payload }: ReturnType<typeof colorThemeSlice.actions.setAppThemeAction>) {
    yield apply(localStorage, 'setItem', [LOCAL_STORAGE_APP_THEME_KEY, payload]);
}

export function* colorThemeSagas() {
    yield takeEvery(colorThemeSlice.actions.setUserThemeAction, setUserThemeSaga);
    yield takeEvery(colorThemeSlice.actions.setAppThemeAction, setAppThemeSaga);
}